import { create } from 'zustand';
import type { StoreLocation } from '../data/types';

interface LocationsStore {
  locations: StoreLocation[];
  setLocations: (locations: StoreLocation[]) => void;
  addLocation: (location: Omit<StoreLocation, 'id'>) => void;
  updateLocation: (id: string, updates: Partial<StoreLocation>) => void;
  removeLocation: (id: string) => void;
  getLocationById: (id: string) => StoreLocation | undefined;
  getLocationName: (id: string) => string;
}

export const useLocations = create<LocationsStore>((set, get) => ({
  locations: [],
  setLocations: (locations) => set({ locations }),
  addLocation: (location) =>
    set((state) => ({
      locations: [...state.locations, { ...location, id: crypto.randomUUID() }],
    })),
  updateLocation: (id, updates) =>
    set((state) => ({
      locations: state.locations.map((l) =>
        l.id === id ? { ...l, ...updates } : l
      ),
    })),
  removeLocation: (id) =>
    set((state) => ({
      locations: state.locations.filter((l) => l.id !== id),
    })),
  getLocationById: (id) => get().locations.find((l) => l.id === id),
  getLocationName: (id) => get().locations.find((l) => l.id === id)?.name ?? id,
}));
